import React, { Component } from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { injectIntl } from 'react-intl';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

import { FormattedMessage } from 'react-intl';
import { closeDescriptionModal } from '../../actions/siteadmin/modalActions';
import messages from '../../locale/messages';
import bt from '../../components/commonStyle.css';
import s from './DescriptionModal.css';



class DescriptionModal extends Component {

    render() {
        const { jobDescriptionModal, closeDescriptionModal, jobDescriptionData } = this.props;
        return (
            <Modal show={jobDescriptionModal} onHide={closeDescriptionModal} dialogClassName='commonModalContainer'>
                <Modal.Header closeButton className='commonModalHeader'>
                    <Modal.Title>
                        <div className="commonModalTitle"> <FormattedMessage {...messages.jobDescription} /></div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className='commonModalBody'>
                    <div className={cx(s.descriptionModalInfoHeading)}>{jobDescriptionData?.name}</div>
                    <div className={cx(s.descriptionModalInfoDesc)}>{jobDescriptionData?.description}</div>
                </ Modal.Body >
            </Modal>
        )
    }
}
const mapState = (state) => ({
    jobDescriptionModal: state.adminModalStatus.jobDescriptionModal,
    jobDescriptionData: state?.adminModalStatus?.jobDescriptionData,
});

const mapDispatch = {
    closeDescriptionModal
};

export default injectIntl(withStyles(bt, s)(connect(mapState, mapDispatch)(DescriptionModal)));